<ng-container *ngIf="!isLoading">
    <ng-container *ngFor="let model of models">
    <div [style]="'--color-corp-1:' + colorCorp +'; background: ' + colorCorp" class="ticket-wrapper">
        <div class="ticket" [ngClass]="model.isDeleted ? 'deleted' : ''">
            <ng-container *ngIf="model">
                <div class="title">{{ model.ticket.eventName || model.ticket.title}}</div>
                @if (purchaseSessionStart(model); as sessionStart) {
                    <div class="subtitle session-subtitle">
                        {{ sessionStart | date:"EEEE, d 'de' MMMM 'de' y • HH:mm" }}
                    </div>
                }
                @if (model.ticket?.startEvent){
                    <div class="subtitle">
                        {{model.ticket.startEvent | date:'d/MM/yyyy HH:mm'}}
                    </div>
                }
                <hr>
                <div class="user">
                    <h2>{{model.userFullName}}</h2>
                    <div>{{model.userMail}}</div>
                </div>
                <hr>
                <div class="detail">
                    <table>
                        <tr *ngFor="let d of model.details">
                            <td>{{d.ticketPriceName}}</td>
                            <td>{{d.quantity}}</td>
                        </tr>
                        <tr class="total">
                            <td><b>{{ ticketKey('TOTAL_TICKETS') | translate }}</b></td>
                            <td><b>{{model.totalQuantity}}</b></td>
                        </tr>
                        <tr class="total" *ngIf="model.total == 0">
                            <td colspan="2" class="ion-text-center">
                                <b>{{'Free' | translate}}</b>
                            </td>
                        </tr>
                        <tr class="total" *ngIf="model.total > 0">
                            <td colspan="2" class="ion-text-center">
                                <b>{{model.total | currency: 'EUR'}}</b>
                            </td>
                        </tr>

                    </table>
                    <p-accordion styleClass="mt-4" [activeIndex]="0">
                        <p-accordionTab  class="title-acordion" [header]="'Ticketing.PURCHASE_DETAILS' | translate">
                            <table id="more-info-table">
                                <tr>
                                    <td><b>{{ 'PurchaseDate' | translate }}</b></td>
                                </tr>
                                <tr>
                                    <td class="break-word">{{model.createdAt | date:'d/MM/yyyy HH:mm'}}</td>
                                </tr>
                                <tr>
                                    <td class="details-section-title">{{ 'Ticketing.ResponsibleData' | translate }}</td>
                                </tr>
                                <tr>
                                    <td><b>{{ 'BUYER' | translate }}</b></td>
                                </tr>
                                <tr>
                                    <td class="break-word">{{model.buyer?.fullName}}</td>
                                </tr>

                                @if (purchaseSessionStart(model); as sessionStart) {
                                    <tr>
                                        <td><b>{{ 'Ticketing.SESSION' | translate }}</b></td>
                                    </tr>
                                    <tr>
                                        <td class="break-word">
                                            {{ sessionStart | date:"EEEE, d 'de' MMMM 'de' y • HH:mm" }}
                                        </td>
                                    </tr>
                                }

                                @if (model?.buyer?.email) {
                                    <!--<tr>
                                        <td><b>{{ 'Email' | translate }}</b></td>
                                        <td class="break-word">{{ model?.buyer?.email }}</td>
                                    </tr>-->
                                }

                                @for (cf of purchaseCustomFieldsByLocation(model, 'PARENT'); track $index) {
                                    <tr>
                                        <td><b>{{cf.customFieldName}}</b></td>

                                    </tr>
                                    <tr>
                                        <td class="break-word">
                                            <app-custom-field-input
                                                    [ngModel]="cf.value"
                                                    [type]="cf.customFieldType"
                                                    [readonly]="true"
                                            />
                                        </td>
                                    </tr>
                                }

                                <tr>
                                    <td class="details-section-title">{{ 'Ticketing.HolderData' | translate }}</td>
                                </tr>
                                @for (cf of purchaseCustomFieldsByLocation(model, 'CHILDREN'); track $index) {
                                    <tr>
                                        <td><b>{{cf.customFieldName}}</b></td>

                                    </tr>
                                    <tr>
                                        <td class="break-word">
                                            <app-custom-field-input
                                                    [ngModel]="cf.value"
                                                    [type]="cf.customFieldType"
                                                    [readonly]="true"
                                            />
                                        </td>
                                    </tr>
                                }
                            </table>

                        </p-accordionTab>
                    </p-accordion>
                    <div class="d-print-none cursor-pointer w-100 text-center mt-4 mb-3" *ngIf="model.price === 0 && model.ticket?.cancelable">
                        <span *ngIf="!isLoading && !model.isDeleted" class="text-danger text-m cursor-pointer " (click)="CancelTicket(model.uuid)">{{'TICKETING.cancelTicketButton'|translate}}</span>

                        <div *ngIf="isLoading" class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                <div class="rip">
                    <div class="circleLeft"></div>
                    <div class="ripLine"></div>
                    <div class="circleRight"></div>
                </div>


                <div class="qr-wrapper" >
                    <div class="text">{{ 'TICKETS.SHOW_QR_AT_ENTRANCE' | translate }}</div>
                    <qrcode *ngIf="!model.isDeleted"
                            [qrdata]="model.qrData"
                            [width]="128"
                            [margin]="0"
                            errorCorrectionLevel="M"
                            elementType="img">
                    </qrcode>
                    <img *ngIf="model.isDeleted" width="40%" [src]="model.deletedQrImage">
                    <p class="my-2 text-s text-dark"> {{model.uuid}}</p>
                </div>
                <div class="subdetail">
                    <div class="code"></div>
                    <div class="time">{{ model.createdAt| date:'d/MM/yyyy HH:mm:ss' }}</div>
                </div>
                <div class="shadow"></div>
            </ng-container>
        </div>
    </div>
    </ng-container>
</ng-container>
